<style>
  #MyListMenu li {
    list-style: none;
  }

  .Lvl2 {
    margin: 10px 20px;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title" *ngIf="inner_PM.id==0">Add </h5>
    <h5 class="card-title" *ngIf="inner_PM.id>0">Edit </h5>
    <br>
    <br>

    <form [formGroup]="PMForm">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Title</label>
          <input formControlName="Title" type="text" class="form-control" placeholder="Type here...">
          <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched"
            class="form-text text-muted MyErrorRedColor">Enter the title.</small>
        </div>

        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Days</label>

          <select class="custom-select" formControlName="Duration">
            <option value="0">Select</option>
            <option *ngFor="let item of DataList_PM_Duration" [value]="item.id">{{item.title}}</option>
          </select>
        </div>


      </div>
    </form>

    <br />
    <hr />
    <br />

    <h5 class="card-title">Service Interval Checklist</h5>

    <div class="row">

      <ng-container *ngFor="let lvl1 of DataList_PM_Item">

        <div class="form-group col-md-3">
          <ul d="MyListMenu">
            <b>{{lvl1.title}}</b>

            <li *ngFor="let lvl2 of lvl1.detail" style="list-style: none;">
              <input type="checkbox" class="Lvl2" (change)="item_Data_Change(lvl2)" [checked]="lvl2.selected" /> {{lvl2.title}}
            </li>

          </ul>
        </div>

      </ng-container>


    </div>

    <br />
    <hr />
    <br />

    <h5 class="card-title">Service Interval Users</h5>

    <div class="row">

      <ul id="MyListMenu">

        <li *ngFor="let lvl2 of DataList_User" >
          <input type="checkbox" class="Lvl2" (change)="user_Data_Change(lvl2)" [checked]="lvl2.del" /> {{lvl2.name}} {{lvl2.familly}}
        </li>

      </ul>


    </div>

    <br />
    <hr />
    <br />


    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />

    <button *ngIf="!InProccessing && inner_PM.id==0" type="button" (click)="SubmitPMForm()" [disabled]="!PMForm.valid"
      class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>

    <button *ngIf="!InProccessing && inner_PM.id>0" type="button" (click)="SubmitPMForm()" [disabled]="!PMForm.valid"
      class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Edit </button>

  </div>
</div>
